import { createStore } from 'jotai'
import { createContext, useContext } from 'react'

export type FontPickerStore = ReturnType<typeof createStore>

export const FontPickerStoreContext = createContext<FontPickerStore | null>(null)

export function createFontPickerStore(): FontPickerStore {
	return createStore()
}

export function useFontPickerStore(): FontPickerStore {
	const store = useContext(FontPickerStoreContext)
	if (!store) {
		throw new Error('useFontPickerStore must be used within a FontPickerManager')
	}
	return store
}
